import { LogEntry } from './../api/dtos/LogEntry.schema.d'
import { LogEventType } from './../api/dtos/LogEventType.schema.d'
import { RentalStatus } from '@/api/dtos/RentalStatus.schema'
import { Pricing } from '@/api/dtos/Pricing.schema'

export function rentalStatusToGerman (rentalStatus: RentalStatus): string {
  const mapping: { [k in RentalStatus]: string } = {
    CREATED: 'erstellt',
    PAYED: 'bezahlt',
    CONFIRMED: 'bestätigt',
    RUNNING: 'laufend',
    DONE: 'beendet',
    CANCELLED: 'storniert'
  }
  return mapping[rentalStatus]
}

export function eventTypeToGerman (eventType: LogEventType): string {
  const mapping: {
    [Property in LogEventType]: string
  } = {
    BOOKING: 'Buchung',
    BOX_OPENING: 'Türöffnung',
    BOX_CONFIG: 'Box-Konfiguration',
    STATION_CONFIG: 'Stations-Konfiguration',
    CONTROLLER: 'Controller',
    UPDATE: 'Firmware',
    OPERATOR_CONFIG: 'Betreiber-Konfiguration',
    ADMIN_CONFIG: 'Admin-Konfiguration',
    USER_CONFIG: 'Benutzer-Konfiguration'
  }
  return mapping[eventType]
}

export function logEntryToGerman (logEntry: LogEntry): string {
  switch (logEntry.category) {
    case 'ADMIN_CONFIG':
      return 'Admin-Konfiguration'
    case 'BOOKING':
      return 'Buchung'
    case 'BOX_CONFIG':
      return 'Box-Konfiguration'
    case 'BOX_OPENING':
      return 'Box-Öffnung'
    case 'CONTROLLER':
      return 'Controller'
    case 'OPERATOR_CONFIG':
      return 'Betreiber-Konfiguration'
    case 'STATION_CONFIG':
      return 'Stations-Konfiguration'
    case 'UPDATE':
      return 'Update'
    case 'USER_CONFIG':
      return 'Benutzer-Konfiguration'
    default:
      return 'Logeintrag'
  }
}

export function deviceTypeAndPropertiesToGerman (pricing: Pricing): string {
  let result = pricing.deviceType
  if (pricing.deviceProperties.length > 0) {
    result += ' mit '
    result += pricing.deviceProperties.map((deviceProperty) => deviceProperty).join(', ')
  }
  return result
}
